import type { Node } from "prosemirror-model";
import { type EditorState, NodeSelection, type Selection, TextSelection, type Transaction } from "prosemirror-state";

const isGallery = (node: Node) => node.type.name === "gallery";

const selectedGalleryPos = (selection: Selection): number | null => {
	if (!(selection instanceof NodeSelection)) return null;
	if (isGallery(selection.node)) return selection.from;
	if (isGallery(selection.$from.parent)) return selection.$from.before();
	return null;
};

const placeCursorAfterGallery = (state: EditorState): Transaction | null => {
	const galleryPos = selectedGalleryPos(state.selection);
	if (galleryPos === null) return null;

	const after = galleryPos + state.doc.nodeAt(galleryPos).nodeSize;
	const tr = state.tr.insert(after, state.schema.nodes.paragraph.create());
	return tr.setSelection(TextSelection.create(tr.doc, after + 1));
};

export default placeCursorAfterGallery;
